import type { Ref } from 'vue'
import { defineStore } from 'pinia'
import type { Skill } from '@prisma/client'
import type { SkillWithRepos } from '../types/custom'

export declare interface SkillStore {
  skills: Ref<Skill[]>
  skill: Ref<SkillWithRepos | null>
  setSkills(_skills?: Skill[] | Ref<Skill[]>): void
  setSkill(skill: Skill): void
}

export const useSkill = defineStore('skill', (): SkillStore => {
  const skills: Ref<Skill[]> = ref([])
  const skill: Ref<SkillWithRepos | null> = ref(null)

  function setSkills(_skills: Skill[]): void {
    skills.value = _skills
  }

  function setSkill(_skill: SkillWithRepos) {
    skill.value = _skill
  }

  return {
    skills,
    skill,
    setSkill,
    setSkills,
  }
})
